export default __webpack_public_path__ + "static/media/Brice-Bold.88870cae.otf";